import styled from "styled-components"
import { scale, colors, breakpoint } from "../../styles"
import { AccordionHeaderProps, AccordionPanelStyledProps } from "./types"

export const HeaderStyled = styled.button.attrs<AccordionHeaderProps>(
	(props) => ({
		id: `header-${props.id}`,
		"aria-expanded": props.expanded ? `true` : `false`,
		"aria-controls": `panel-${props.id}`,
		"aria-label": props.toggleLabel || undefined,
	})
) <AccordionHeaderProps>`
	position: relative;
	display: flex;
	align-items: center;
	flex-shrink: 0;
	padding: ${scale.px(2.25)} ${scale.px(2)};
	overflow: hidden;
	background-color: ${(props) =>
		(props.expanded && !props.noBackground) ? colors.blue11 : "transparent"};
	color: ${colors.navy};
	border-top: 1px solid ${colors.blue33};
	border-bottom: ${(props) =>
		props.expanded ? "none" : `1px solid ${colors.blue33}`};
	margin-top: -1px;

	${breakpoint("l")`
		padding: ${scale.px(2.25)} ${scale.px(3)};
	`}

	& > svg {
		position: absolute;
		top: 50%;
		right: ${scale.px(1.5)};
		transition: transform 0.2s cubic-bezier(0.7, 0, 0.84, 0);
		transform: ${(props) =>
		props.expanded
			? `translateY(-50%) rotate(-180deg)`
			: `translateY(-50%) rotate(0)`};

		${breakpoint("l")`
			right: ${scale.px(2.5)};
		`}
	}

	&:hover,
	&:focus {
		${(props) =>
		(props.expanded && !props.noBackground) ? colors.blue11 : "transparent"};
		svg {
			fill: ${colors.hoverBlue};
		}
	}
	
	&:focus-visible {
		background-color: ${colors.blue11};
		svg {
			fill: ${colors.hoverBlue};
		}
	}
`

export const PanelStyled = styled.div
	.withConfig({
		shouldForwardProp: (prop: any, defaultValidatorFn: any) =>
			!["id"].includes(prop) && defaultValidatorFn(prop),
	})
	.attrs<AccordionPanelStyledProps>((props) => ({
		id: `panel-${props.id}`,
		role: "region",
		"aria-labelledby": `header-${props.id}`,
		"aria-hidden": props.expanded ? `false` : `true`,
	})) <AccordionPanelStyledProps>`
		height: ${(props) => (props.expanded ? "auto" : "0")};
		visibility: ${(props) => (props.expanded ? "visible" : "hidden")};
		overflow: hidden;
		background-color: ${(props) =>
		(props.expanded && !props.noBackground) ? colors.blue11 : "transparent"};
`

export const PanelInnerStyled = styled.div``
